import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const ReportTags = ({ tags = [], onTagPress, style }) => {
  if (!tags || tags.length === 0) return null;

  const formatTagText = (tag) => {
    const categoryLabels = {
      'sector': 'Sector',
      'cuartel': 'Cuartel', 
      'cultivo': 'Cultivo',
      'estado': 'Estado',
      'zona': 'Zona',
      'edificio': 'Edificio',
      'material': 'Material',
      'tramo': 'Tramo',
      'tipo': 'Tipo',
      'condicion': 'Condición',
      'perimetro': 'Perímetro',
      'nivel': 'Nivel'
    };
    
    const categoryLabel = categoryLabels[tag.category?.toLowerCase()] || tag.category;
    return `${categoryLabel}: ${tag.value}`;
  };

  return (
    <View style={[styles.container, style]}>
      {tags.map((tag, index) => (
        <TouchableOpacity
          key={index}
          style={[styles.tag, { backgroundColor: tag.color }]}
          onPress={() => onTagPress && onTagPress(tag)}
        >
          <Text style={styles.tagText}>
            {formatTagText(tag)}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginVertical: 6,
  },
  tag: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 16,
    marginRight: 8,
    marginBottom: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
  tagText: {
    color: 'white',
    fontSize: 11,
    fontWeight: '600',
    textShadowColor: 'rgba(0, 0, 0, 0.3)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 1,
  },
});

export default ReportTags;